
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M11.164 23.624l12.46-12.46c.242-.243.376-.565.376-.908V1.285C24 .576 23.424 0 22.716 0h-8.972c-.343 0-.665.134-.908.377L.376 12.837a1.276 1.276 0 00-.376.908c0 .343.134.665.376.908l8.971 8.971c.501.5 1.316.5 1.817 0zm-1.14-.676l-8.972-8.971a.326.326 0 010-.464l12.46-12.46a.326.326 0 01.232-.096h8.972c.18 0 .328.147.328.328v8.97c0 .088-.034.17-.096.233l-12.46 12.46a.326.326 0 01-.465 0z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M21.313 2.687a1.663 1.663 0 00-2.835 1.174c0 .444.173.861.486 1.175.314.314.731.486 1.175.486a1.663 1.663 0 001.174-2.835zM19.641 4.36a.7.7 0 01-.207-.499.706.706 0 11.206.498zM7.08 9.661l.119-.12a.478.478 0 00-.676-.676l-.12.12a.477.477 0 000 .676c.187.187.49.187.676 0zM2.729 14.012l3.298-3.3a.478.478 0 00-.676-.675l-3.299 3.299a.476.476 0 000 .676c.187.186.49.186.677 0z","fill":"#E2E4EC"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    